// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
}

.modal-content {
  background: white;
  padding: 32px;
  border-radius: 12px;
  max-width: 800px;
  width: calc(100vw - 40px);
  position: relative;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.modal-close {
  position: absolute;
  top: 16px;
  right: 16px;
  background: none;
  border: none;
  font-size: 28px;
  cursor: pointer;
  color: #666;
  line-height: 1;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-close:hover {
  color: #000;
}

.modal-content h2 {
  margin: 0 0 8px 0;
  font-size: 24px;
  font-weight: 600;
}

.modal-content p {
  margin: 0 0 20px 0;
  color: #666;
  line-height: 1.5;
}

.modal-content form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.modal-input {
  padding: 12px 16px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 16px;
  font-family: inherit;
}

.modal-input:focus {
  outline: none;
  border-color: #000;
}

.modal-input:disabled {
  background: #f5f5f5;
  cursor: not-allowed;
}

.modal-button {
  padding: 12px 24px;
  background: #000;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  font-family: inherit;
}

.modal-button:hover:not(:disabled) {
  background: #333;
}

.modal-button:disabled {
  background: #999;
  cursor: not-allowed;
}

.modal-error {
  background: #fee;
  color: #c33;
  padding: 12px 16px;
  border-radius: 6px;
  font-size: 14px;
}

.modal-hint {
  font-size: 14px;
  color: #999;
  text-align: center;
  margin-top: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/LoginModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,cAAc;EACd,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB","sourcesContent":[".modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10000;\n}\n\n.modal-content {\n  background: white;\n  padding: 32px;\n  border-radius: 12px;\n  max-width: 800px;\n  width: calc(100vw - 40px);\n  position: relative;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n}\n\n.modal-close {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  background: none;\n  border: none;\n  font-size: 28px;\n  cursor: pointer;\n  color: #666;\n  line-height: 1;\n  padding: 0;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.modal-close:hover {\n  color: #000;\n}\n\n.modal-content h2 {\n  margin: 0 0 8px 0;\n  font-size: 24px;\n  font-weight: 600;\n}\n\n.modal-content p {\n  margin: 0 0 20px 0;\n  color: #666;\n  line-height: 1.5;\n}\n\n.modal-content form {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.modal-input {\n  padding: 12px 16px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 16px;\n  font-family: inherit;\n}\n\n.modal-input:focus {\n  outline: none;\n  border-color: #000;\n}\n\n.modal-input:disabled {\n  background: #f5f5f5;\n  cursor: not-allowed;\n}\n\n.modal-button {\n  padding: 12px 24px;\n  background: #000;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-size: 16px;\n  font-weight: 500;\n  cursor: pointer;\n  font-family: inherit;\n}\n\n.modal-button:hover:not(:disabled) {\n  background: #333;\n}\n\n.modal-button:disabled {\n  background: #999;\n  cursor: not-allowed;\n}\n\n.modal-error {\n  background: #fee;\n  color: #c33;\n  padding: 12px 16px;\n  border-radius: 6px;\n  font-size: 14px;\n}\n\n.modal-hint {\n  font-size: 14px;\n  color: #999;\n  text-align: center;\n  margin-top: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
